module.exports = __webpack_public_path__ + "static/img/s2.cf9482e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/an/s2.png
// module id = ros4
// module chunks = 1